import { BaseEntity } from "./data/base_types";


export class CutType extends BaseEntity {
  number: number = 0;
  id_year: string = "";
  id_eco_version: number | null = null;
  name: string = "";
  type: string = "";
  note: string | null = null;
  visible_for: string = "admin"; // 'admin', 'all', 'none'
  clear_cut: boolean = false;
  copy_data: boolean = false;
  copy_id_year: string | null = null;
  copy_id_eco_version: number | null = null;
  copy_name: string | null = null;
  copy_year_name: string | null = null;
  copy_type: string | null = null;
  copy_all_filials: boolean = false;
  copy_filial: boolean = false;
  copy_filial_name: any = null;
  copy_facility: boolean = false;
  copy_facility_name: any = null;
  copy_objects: boolean | null = false;
  copy_grouped_objects: boolean | null = false
  copy_contractor: boolean | null = false;
  copy_tariffs_structure: boolean | null = false;
  copy_tariffs_value: boolean | null = false;
  copy_ok_xn_loss_value: boolean | null = false;
  copy_shop_structure: boolean | null = false;
  copy_shop_value: boolean | null = false;
  copy_realization_structure: boolean | null = false;
  copy_realization_value: boolean | null = false;
  copy_transport_expenses_structure: boolean | null = false;
  copy_transport_expenses_value: boolean | null = false;
  copy_transport_revenue_structure: boolean | null = false;
  copy_transport_revenue_value: boolean | null = false;
  copy_fb_tec_loses: boolean | null = false;
  copy_fb_use_leave: boolean | null = false;
  copy_fb_com_loses: boolean | null = false;
  // Новое поле для опции расчёта стоимости строго по тарифу
  strict_tariff_calc: boolean = false;
  strong_tariff_calc: boolean = false;
}

export class AllowedCut extends CutType {
  is_allow: boolean = false;
}

export class CutWithAccept extends CutType {
  acceptance: boolean = false;
  january: boolean = false;
  february: boolean = false;
  march: boolean = false;
  april: boolean = false;
  may: boolean = false;
  june: boolean = false;
  july: boolean = false;
  august: boolean = false;
  september: boolean = false;
  october: boolean = false;
  november: boolean = false;
  december: boolean = false;
  // Новое поле для опции расчёта стоимости строго по тарифу (дублируется для совместимости)
  strong_tariff_calc: boolean = false;
  visible_for: string = "admin";
}

export type MonthCodeType = "january" | "february" | "march" | "april" | "may" | "june" | "july" | "august" | "september" | "october" | "november" | "december";

export class CutHistoryType extends BaseEntity {
  id_cut: string = "";
  crud_type: string = "";
  content: any = {};

}

export class CutHistoryContentType extends BaseEntity {
  new: any = {};
  old: any = {};
  visible_for: string = "admin";
}

export class TariffHistoryType extends BaseEntity {
  id_cut: string = "";
  crud_type: number | null = null;
  content: any = {};

}

export class YearType {
  id: string;
  name: number;
  is_used: boolean = false;
}

export class Period {
  name: string;
  display: string;
}

export class FacilityType extends BaseEntity {
  id_heat_node: string;
  name: string;
}

export class EcoObjectType extends BaseEntity {
  id: number;
  uid: number | null = null;
  version_id: number;
  name: string;
  short_name: string;
  code: string | null = null;
  date_from: string | null = null;
  date_to: string | null = null;
  relation_from: string | null = null;
  relation_to: string | null = null;
  type_id: number | null = null;
  type_name: string | null = null;
  order_by: number | null = null;
  group_id: number | null = null;
  parent_id: number | null = null;
  parent_name: string | null = null;
  filial_id: number | null = null;
  filial_uid: number | null = null;
  filial_name: string | null = null;
  object_type_id: number | null = null;
}

export class EcoFilialNodesFlatType extends BaseEntity {
  id: number;
  name: string;
  filial_id: number;
  filial_name: string;
}

// Маппинг id тепловых узлов к id филиала
export interface EcoFilialNodeMapType {
  [key: number]: number;
}

interface EcoSelectionBase {
  id: number;
  name: string;
  check: boolean | null;
  date_from?: string | null;
}



export interface EcoNodeFacilitiesTreeItem {
  id: number;
  uid: number;
  name: string;
  objects?: any[];
}

interface EcoNodeFacilitiesTree {
  name: string;
  objects: EcoNodeFacilitiesTreeItem;
}

interface EcoNodeFacilitiesTreeType {
  [key: number]: EcoNodeFacilitiesTree;
}

interface EcoFilialNodeFacilitiesTree {
  name: string;
  nodes: EcoNodeFacilitiesTreeType
}

// Маппинг id филиалов с осдержащимися даннными теппловых узлов и объектов ТУ
export interface EcoFilialNodeFacilitiesTreeMap {
  [key: number]: EcoFilialNodeFacilitiesTree;
}


// Тип данных для уровня тепловых узорв в дереве выбора ТУ
export interface EcoNodeSelectionType extends EcoSelectionBase {
  facilities?: EcoSelectionBase[];
}

// Тип данных для уровня филиалов в дереве выбора ТУ
export interface EcoFilialSelectionType extends EcoSelectionBase {
  nodes: EcoNodeSelectionType[];
}

export class EcoVersionType extends BaseEntity {
  is_main: boolean = false;
  version_type_id: number;
  name: string;
  is_active: boolean = false;
  is_fixed: boolean = false;
  dt_input: string | null = null;
  comment: string | null = null;
}


export class PtnBuisnessPeriondType extends BaseEntity {
  id: number;
  name: string;
  is_month_view: boolean = false;
}

export class UserPreset extends BaseEntity {
  id_user: string | null = null;
  id_eco_filial: number | null = null;
  id_eco_heat_node: number | null = null;
  id_eco_facility: number | null = null;
  id_year: string | null = null;
  id_cut: string | null = null;
  id_secondary_cut: string | null = null;
  period: any = null;
  losses_show_volume: boolean = true;
  buy_show_volume: boolean = true;
  buy_show_price: boolean = false;
  buy_show_price_total: boolean = false;
  buy_show_cost: boolean = false;
  buy_show_cost_delta: boolean = false
  buy_show_cost_total: boolean = false
  sale_show_volume: boolean = true;
  sale_show_price: boolean = false;
  sale_show_price_total: boolean = false;
  sale_show_cost: boolean = false;
  sale_show_cost_delta: boolean = false
  sale_show_cost_total: boolean = false
  transport_cost_show_volume: boolean = true;
  transport_cost_show_price: boolean = false;
  transport_cost_show_price_total: boolean = false;
  transport_cost_show_cost: boolean = false;
  transport_cost_show_cost_delta: boolean = false
  transport_cost_show_cost_total: boolean = false
  transport_gain_show_volume: boolean = true;
  transport_gain_show_price: boolean = false;
  transport_gain_show_price_total: boolean = false;
  transport_gain_show_cost: boolean = false;
  transport_gain_show_cost_delta: boolean = false
  transport_gain_show_cost_total: boolean = false
  show_cut: boolean = true;
  show_secondary_cut: boolean = false;
  show_imbalance: boolean = false
}

export class Contractor extends BaseEntity {
  name : string = "";
  model_name : string | null = null;
  model_name_eco : number | null = null;
  heat_biling_method : string | null = "УУТЭ";
  gvo_biling_method : string | null = "УУТЭ";
  internal_turnover : boolean | null = false;
  vgo_fb : boolean | null = false;
  reg_kind_activity : boolean | null = false;
  purchase : boolean | null = false;
  realization : boolean | null = false;
  transport_expenses : boolean | null = false;
  transport_revenue : boolean | null = false;
  id_cut : string = "";
  id_eco_heat_node: number;
  purchase_disable: boolean = false;
  realization_disable: boolean = false;
  transport_expenses_disable: boolean = false;
  transport_revenue_disable: boolean = false;
}

export class  OkHnRow extends BaseEntity {
  id_cut: string = "";
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_heat_carrier: number | null = null;
  vol_te: number = 0;
  is_steam_total_block: boolean | null = false;
  is_total_block: boolean | null = false;
}

export class  Purchase extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_contractor: string = "";
  id_tarif: string = "";
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  cost_total:number = 0;
  contractor_instance_id: string | null = null
  tariff_instance_id: string | null = null
}

export class  PurchaseTotal extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_heat_carrier: number | null = null;
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  price_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  price_power: number = 0;
  price_total: number = 0;
  cost_total: number = 0;
  is_steam_total_block: boolean | null = false;
  is_total_block: boolean | null = false;
  is_total: boolean | null = false;
  contractor_instance_id: string | null = null
  tariff_instance_id: string | null = null
}

export class  EditFieldsTariff {
  te: any;
  power: any;
}

export class Tariff extends BaseEntity {
  view : string = "";
  is_Edited : boolean = false;
  sign_internal_turnover : string | null = null;
  value_group: string = "";
  id_heat_carrier: number | null = null;
  collectors : boolean = false;
  heating_system : boolean = false;
  revenue : boolean = false;
  expenses : boolean = false;
  two_part : boolean = false;
  description : string = "";
  id_cut: number | string | null = null;
  id_eco_heat_node: number | null = null;
  edit_fields: any = new EditFieldsTariff();
  instance_id: string | null = null;

  january_we : number = 0.00;
  february_we : number = 0.00;
  march_we : number = 0.00;
  april_we : number = 0.00;
  may_we : number = 0.00;
  june_we : number = 0.00;
  july_we : number = 0.00;
  august_we : number = 0.00;
  september_we : number = 0.00;
  october_we : number = 0.00;
  november_we : number = 0.00;
  december_we : number = 0.00;
  january_wp : number | null = 0.00;
  february_wp : number | null = 0.00;
  march_wp : number | null = 0.00;
  april_wp : number | null = 0.00;
  may_wp : number | null = 0.00;
  june_wp : number | null = 0.00;
  july_wp : number | null = 0.00;
  august_wp : number | null = 0.00;
  september_wp : number | null = 0.00;
  october_wp : number | null = 0.00;
  november_wp : number | null = 0.00;
  december_wp : number | null = 0.00;

  index_february_we: number | null = 0.00;
  index_march_we: number | null = 0.00;
  index_april_we: number | null = 0.00;
  index_may_we: number | null = 0.00;
  index_june_we: number | null = 0.00;
  index_july_we: number | null = 0.00;
  index_august_we: number | null = 0.00;
  index_september_we: number | null = 0.00;
  index_october_we: number | null = 0.00;
  index_november_we: number | null = 0.00;
  index_december_we: number | null = 0.00;
  index_february_wp: number | null = 0.00;
  index_march_wp: number | null = 0.00;
  index_april_wp: number | null = 0.00;
  index_may_wp: number | null = 0.00;
  index_june_wp: number | null = 0.00;
  index_july_wp: number | null = 0.00;
  index_august_wp: number | null = 0.00;
  index_september_wp: number | null = 0.00;
  index_october_wp: number | null = 0.00;
  index_november_wp: number | null = 0.00;
  index_december_wp: number | null = 0.00;

  is_used: boolean = false;
  is_accepted: number[] = []
}




export class  Sale extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_contractor: string = "";
  id_tarif: string = "";
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  cost_total:number = 0;
  tariff_instance_id: string | null =null
  contractor_instance_id: string | null = null
}

export class SaleTotal extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_heat_carrier: number | null = null;
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  price_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  price_power: number = 0;
  price_total: number = 0;
  cost_total: number = 0;
  is_steam_total_block: boolean = false;
  is_total_block: boolean = false;
  is_total: boolean = false;
  tariff_instance_id: string | null =null
  contractor_instance_id: string | null = null
}

export class UniversalData extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_contractor: string = "";
  id_tarif: string = "";
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  cost_total:number = 0;
  isFocused: boolean = false;
  c_order: number | null = null;
  
  tariff_instance_id: string | null = null
  contractor_instance_id: string | null = null
}

class MonthValues {
  accepted: boolean | null = false;

}

class Months {
  january: MonthValues = new MonthValues();
  february: MonthValues = new MonthValues();
  march: MonthValues = new MonthValues();
  april: MonthValues = new MonthValues();
  may: MonthValues = new MonthValues();
  june: MonthValues = new MonthValues();
  july: MonthValues = new MonthValues();
  august: MonthValues = new MonthValues();
  september: MonthValues = new MonthValues();
  october: MonthValues = new MonthValues();
  november: MonthValues = new MonthValues();
  december: MonthValues = new MonthValues();
}

export class Accept extends BaseEntity {
  id_year: string | null = null;
  id_cut: string | null = null;
  id_eco_facility: number | null = null;
  month: number | null = null;
  blocks: any = null;
  full_accept: boolean | null = null;
  partial_accept: boolean | null = null;
}

export class AcceptData extends BaseEntity {
  id_year: string | null = null;
  id_cut: string | null = null;
  id_object: string | number | null = null;
  id_eco_facility: number | null = null;
  id_filial: string[] | number[] | null = null;
  months: number[][] = [];
  month: number | null = null;
  all_blocks: boolean = false;
  all_filials: boolean = false;
  all_objects: boolean = false;
  blocks: any = null;
}

export class AcceptDataBackend extends BaseEntity {
  id_cut: string | null = null;
  id_object: string | number | null = null;
  month: number = -1;
  blocks: any = null;
  full_accept: boolean | null = null;
  partial_accept: boolean | null = null;
}

export interface IAcceptResponse {
  [key: string]: Accept[];
}

// Карта id года с вложенными срезками и ассептами для них
export interface IYearAcceptResponseMap {
  [key: string]: IAcceptResponse;
}

export class AcceptAggSchema extends BaseEntity {
  id_object: string | number | null = null;
  filial: string | null = null;
  heat_node: string | null = null;
  object_name: string | null = null;
  blocks: any = null;
}

export class AcceptAggHeadNodeSchema extends BaseEntity {
  name: string | null = null;
  objects: AcceptAggSchema[] = [];
}

export class AcceptAggFilialSchema extends BaseEntity {
  name: string | null = null;
  nodes: any = {};
}

export class AcceptAggListSchema extends BaseEntity {
  request_uuid: string | null = null;
  data: any = {};
}

export class AcceptChangeSchema extends BaseEntity {
  request_uuid: string | null = null;
  months: number[];
  id_node: number | null = null;
  data: AcceptChangeBlockSchema;
}

export class AcceptChangeBlockSchema extends BaseEntity {
  blocks: any
}


export class AcceptLogData extends BaseEntity {
  id_year: string | null = null;
  id_cut: string | null = null;
  id_filial: string[] | number[] | null = null;
  all_filials: boolean = false;
}

export class  TransportCost extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_contractor: string = "";
  id_tarif: string = "";
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  cost_total:number = 0;
}

export class  TransportCostTotal extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_heat_carrier: number | null = null;
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  price_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  price_power: number = 0;
  price_total: number = 0;
  cost_total: number = 0;
  is_steam_total_block: boolean | null = false;
  is_total_block: boolean | null = false;
  is_total: boolean | null = false;
}

export class  TransportIncome extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_contractor: string = "";
  id_tarif: string = "";
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  cost_total:number = 0;
}

export class  TransportIncomeTotal extends BaseEntity {
  id_cut: string = "";
  id_facility: string | null = null;
  id_eco_facility: number;
  id_eco_heat_node: number;
  month: string = "";
  block: string = "";
  id_heat_carrier: number | null = null;
  vol_te: number = 0;
  cost_te: number = 0;
  cost_delta_te: number = 0;
  price_te: number = 0;
  vol_power: number = 0;
  cost_power: number = 0;
  cost_delta_power: number = 0;
  price_power: number = 0;
  price_total: number = 0;
  cost_total: number = 0;
  is_steam_total_block: boolean | null = false;
  is_total_block: boolean | null = false;
  is_total: boolean | null = false;
}


export class ResponseList {
  totalCount: number;
  data: any[];
}

export interface FilialNodeItem {
  filial_id: number;
  filial_name: string;
  id: number;
  name: string;
  date_from: string;

}
interface FilialNodeTreeItem {
  [key: number]: FilialNodeItem;
}

export interface FilialNodeTree {
  [key: number]:  FilialNodeTreeItem;
}

export interface FilialNodeTreeExtended {
  [key: number]:  FilialExtended;
}

export interface FilialExtended {
  filial: EcoObjectType
  nodes: NodesExtended
}

interface NodesExtended {
    [key: number]: NodeItemExtended;
}

interface NodeItemExtended {
  filial_id: number;
  filial_name: string;
  id: number;
  name: string;
  date_from: string;
  node: EcoObjectType
}


// мап времени жизни одного объекта ТУ с разбивкой по месяцам,
// ключ - порядок месяца, значение - существовал ли объект в указанном месяце хотя бы 1 день
interface ObjectLifetimeItemMap {
  [key: number]: boolean
}

// мап времени жизни объектов ТУ с разбивкой по месяцам, ключ - id объекта ТУ
export interface IObjectLifetimeMap {
  [key: number]:  ObjectLifetimeItemMap;
}

export class ImportDiffObject extends BaseEntity {
  id: number;
  uid: string;
  name: string;
  year_id: string;
  cut_id: string;
  month: string;
  month_rus: string;
  diff: boolean;
  parent_id: number | null = null;
  parent_name: string | null = null;
  filial_id: number | null = null;
  filial_name: string | null = null;
  block: string;
  id_heat_carrier: number;
  value_db: number;
  value_import: number;
}

export class IndexCommonData {
  year: string = "";
  cut: string = "";
  january: boolean = false;
  february: boolean = false;
  march: boolean = false;
  april: boolean = false;
  may: boolean = false;
  june: boolean = false;
  july: boolean = false;
  august: boolean = false;
  september: boolean = false;
  october: boolean = false;
  november: boolean = false;
  december: boolean = false;
}

export class ColorThresholdGroup {
  color1: string = "";
  sep1: number = 0;
  color2: string = "";
  sep2: number = 0;
  color3: string = "";

  constructor(data?: Partial<ColorThresholdGroup>) {
    Object.assign(this, data);
  }
}

export class ImbalanceColorSettings {
  imbalance_month: ColorThresholdGroup = new ColorThresholdGroup();
  imbalance_year: ColorThresholdGroup = new ColorThresholdGroup();
  summary_data_common: ColorThresholdGroup = new ColorThresholdGroup();
  control_nodes: ColorThresholdGroup = new ColorThresholdGroup();
  control_filials: ColorThresholdGroup = new ColorThresholdGroup();
  control_month: ColorThresholdGroup = new ColorThresholdGroup();

  constructor(data?: Partial<ImbalanceColorSettings>) {
    if (data) {
      for (const key in this) {
        if (data[key as keyof ImbalanceColorSettings]) {
          this[key as keyof ImbalanceColorSettings] = new ColorThresholdGroup(
            data[key as keyof ImbalanceColorSettings] as Partial<ColorThresholdGroup>
          );
        }
      }
    }
  }
}

export class  GroupedObjects extends BaseEntity {
  id: string = "";
  title: string = "";
  id_cut: string = "";
  facility_ids: number[] = [];
  heat_node_ids: number[] = [];
}

export class  SelectedGroupedObjects extends BaseEntity {
  id: string = "";
  title: string = "";
  check: boolean = false;
}

export class  CreateGroupedObjects extends BaseEntity {
  title: string = "";
  id_cut: string = "";
  facility_ids: number[] = [];
  heat_node_ids: number[] = [];
}

export class  UpdateGroupedObjects extends BaseEntity {
  title: string = "";
  facility_ids: number[] = [];
  heat_node_ids: number[] = [];
}
